import ApiService from "../../Services/ApiService";
import _ from "lodash";

export default {
    state: {
        userCompanyEstimates: [],
        userCompanyActuals: []
    },

    getters: {
        getUserCompanyEstimates(state) {
            return state.userCompanyEstimates;
        },
        getUserActuals(state) {
            return state.userCompanyActuals;
        },
        getUserEtimates(state) {
            let temp = state.userCompanyEstimates.filter((e) => e.user_company_est_id !== undefined);

            temp = _.orderBy(temp, ['period'], ['asc']);

            return temp;
        }
    },

    mutations: {
        setUserCompanyEstimates(state, payload) {
            state.userCompanyEstimates = payload;
        },
        setCompanyActuals(state, payload) {
            state.userCompanyActuals = payload;
        }
    },

    actions: {
        async loadUserCompanyEstimates({ commit }, data) {
            let userCompanyEstimates = (await ApiService.selectEstimates(data.user_id)).data;

            userCompanyEstimates = userCompanyEstimates.filter((e) => e.company_id === data.company_id);

            commit("setUserCompanyEstimates", userCompanyEstimates);
        },
        async loadCompanyActuals({ commit }, company_id) {
            let companyActual = (await ApiService.selectActuals(company_id)).data;

            commit('setCompanyActuals', companyActual);
        },
        async insertEstimate({ commit }, data) {
            await ApiService.insertEstimate(data);

            let userCompanyEstimates = (await ApiService.selectEstimates(data.user_id)).data;
            
            userCompanyEstimates = userCompanyEstimates.filter((e) => e.company_id === data.company_id);

            commit("setUserCompanyEstimates", userCompanyEstimates);
        },
        async updateEstimate({ commit }, data) {
            await ApiService.updateEstimate(data);

            let userCompanyEstimates = (await ApiService.selectEstimates(data.user_id)).data;
            
            userCompanyEstimates = userCompanyEstimates.filter((e) => e.company_id === data.company_id);

            commit("setUserCompanyEstimates", userCompanyEstimates);
        },
        async deleteEstimatesOnUserIdAndCompanyId({ commit }, data) {
            await ApiService.deleteEstimatesOnUserIdAndCompanyId(data);

            let userCompanyEstimates = (await ApiService.selectEstimates(data.user_id)).data;
            
            userCompanyEstimates = userCompanyEstimates.filter((e) => e.company_id === data.company_id);

            commit("setUserCompanyEstimates", userCompanyEstimates);
        }
    }
};
